import {space, UpdateProviderSurveyRequest, UpdateProviderSurveyResponse} from "../../provider_api";
import IProviderSurveyProto = space.kenko.proto.IProviderSurveyProto;
import {useRpcSender} from "../RpcSender";
import {useState} from "react";
import {RpcState} from "../RpcState";
import { useProviderProfile } from "../../ProviderProfileProvider";

export const useUpdateProviderSurvey = () => {

  const {setBusiness, setBusinessProfile} = useProviderProfile();

  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: "none"});

  /**
   * @param results since the last page changes the state and submits this needs to be passed in
   * @param surveyComplete false for incremental drafts; true will submit this for review.
   */
  const send = (results: IProviderSurveyProto, surveyComplete: boolean) => {

    setRpcState({state: 'pending'});
    const request = UpdateProviderSurveyRequest.encode(
        UpdateProviderSurveyRequest.create({
          survey: results,
          surveyComplete: surveyComplete
        })
    ).finish();

    rpcSender.send('update_provider_survey', request)
        .then(value => {
          const response = UpdateProviderSurveyResponse.decode(value);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'Server error updating profile'});
            return;
          }

          setRpcState({state: 'success'});
          setBusiness(response.business);
          // If the alpha user was auto-approved this might exist
          setBusinessProfile(response.profile);
          
        })
        .catch(e => {
          setRpcState({state: 'error', message: 'Network error updating profile'});
        });
  }
  
  return {rpcState, send};
};
